import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const user = localStorage.getItem('user');
  const location = useLocation();
  const pathname = window.location.pathname;

  if (
    !user &&
    pathname !== '/recuperarContrasena' &&
    pathname !== '/resetearContrasena'
  ) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
